export default __webpack_public_path__ + "icon-bookmark.8750c447.png";